import "./App.css";
import MainRoute from "./routes";

const App = () => <MainRoute />;

export default App;
